import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';
import {twMerge} from 'tailwind-merge';

import {EmptyMessage} from './EmptyMessage';

type EmptySharedViewsProps = {
  showClearFilterButton?: boolean;
  onClearFilters?: () => void;
};

export const EmptySharedViews: React.FC<EmptySharedViewsProps> = ({
  showClearFilterButton = true,
  onClearFilters,
}) => {
  return (
    <div
      data-test="empty-shared-views"
      className={twMerge(
        'flex w-[19rem] flex-col items-center gap-8 rounded',
        'mx-16 my-8  px-12 py-16',
        'bg-wb-surface-sunken dark:bg-moonbeam/[.05]'
      )}>
      <div
        className={twMerge(
          'flex h-36 w-36 items-center justify-center rounded-[40px]',
          'bg-wb-surface-selected text-wb-text-link',
          'dark:bg-teal-700/[0.32] dark:text-teal-400'
        )}>
        <Icon name="view-glasses" className="h-20 w-20" />
      </div>
      <div className="text-center">
        <h1 className="text-base font-semibold leading-[22px] text-wb-text-primary dark:text-moon-200">
          {showClearFilterButton ? 'No matching views' : 'No views yet'}
        </h1>
        <p className="text-sm leading-[22px] text-wb-text-tertiary">
          <EmptyMessage
            showClearFilterButton={showClearFilterButton}
            onClearFilters={onClearFilters}
          />
        </p>
      </div>
    </div>
  );
};
